import { type PlanType } from '@/types';

export type MapTemplateAvailability =
  | 'available-visible'
  | 'unavailable-visible'
  | 'available-original'
  | 'unavailable-original'
  | 'unknown';

type MapTemplateAvailabilityDetail = {
  templateId: string;
  templatePlanType: PlanType;
};

type ResolveMapTemplateAvailabilityParams = {
  templateId?: string;
  visibleMapTemplates: MapTemplateAvailabilityDetail[];
  originMapTemplate?: MapTemplateAvailabilityDetail;
  hasEnoughPlanType: (planType: PlanType) => boolean;
};

/**
 * Resolves a selected map template against the current visible catalog and the
 * original quiz metadata. Visibility is not an entitlement check: an original
 * template omitted from the catalog remains available when the current plan
 * can use its recorded plan type.
 */
export const resolveMapTemplateAvailability = ({
  templateId,
  visibleMapTemplates,
  originMapTemplate,
  hasEnoughPlanType,
}: ResolveMapTemplateAvailabilityParams): MapTemplateAvailability => {
  if (!templateId) {
    return 'unknown';
  }

  const visibleMapTemplate = visibleMapTemplates.find(
    mapTemplate => mapTemplate.templateId === templateId,
  );

  if (visibleMapTemplate) {
    return hasEnoughPlanType(visibleMapTemplate.templatePlanType)
      ? 'available-visible'
      : 'unavailable-visible';
  }

  if (originMapTemplate?.templateId === templateId) {
    return hasEnoughPlanType(originMapTemplate.templatePlanType)
      ? 'available-original'
      : 'unavailable-original';
  }

  return 'unknown';
};
